<template>
  <div>
    <div
      class="is-flex is-justify-content-space-between is-hidden-desktop is-hidden-tablet"
      :class="index > 0 ? 'mt-6' : ''"
    >
      <span class="is-size-7 has-text-grey-light mb-1" :key="index"
        >Leg: {{ index + 1 }}</span
      >
      <a class="is-size-7" v-show="notAlone" @click="close">Delete</a>
    </div>

    <div class="is-size-7 has-text-grey-light mb-1 is-hidden-mobile">
      Leg: {{ index + 1 }}
    </div>

    <div class="columns">
      <div class="column is-one-third">
        <EDLocationSearch
          class=""
          :placeholder="fromTitle"
          :value="value.fromLoc"
          @select="nextBox"
          ref="fromLocationInput"
          @locUpdate="
            value.fromLoc = $event;
            nextBox();
          "
          data-test-attr="from-destination-inp"
        />
      </div>
      <div class="column is-one-third">
        <EDLocationSearch
          class=""
          :placeholder="toTitle"
          :value="value.toLoc"
          ref="toLocationInput"
          @locUpdate="setArrivalLocation"
          data-test-attr="to-destination-inp"
        />
      </div>
      <div
        class="column is-one-third"
        :class="value.depDate.advanced.tod === 'Custom' ? 'is-flex' : ''"
      >
        <FlightDateTimeSelector
        data-test="departDate-input"
          ref="departDate"
          :dateIndex="0"
          v-model="value.depDate"
          :placeholder="'Depart Date'"
          :minDate="minDate"
          :maxDate="value.maxDate"
          :focusedDate="minDate"
          :showSummary="false"
          @input="updateRow"
        />
        <!--
          <b-datepicker
            v-model="value.depDate"
            ref="datepicker"
            placeholder="Depart Date"
            :min-date="minDate"
            :max-date="value.maxDate"
            :mobileNative="false"
            @input="updateRow"
          >
          </b-datepicker>
          -->

        <div v-if="value.depDate.advanced.tod === 'Custom'" class="vl"></div>

        <div v-if="value.depDate.advanced.tod === 'Custom'">
          <b-field>
            <div  data-test="outbound-timepicker-multicity">
              <b-timepicker
              
                icon="clock"
                is-small
                placeholder="Depart Time"
                hour-format="12"
                :incrementMinutes=15
                v-model="value.depDate.advanced.time"
              >

              </b-timepicker>
            </div>
          </b-field>
        </div>
      </div>
      <div class="mt-5 is-hidden-mobile">
        <a class="delete is-small" v-show="notAlone" @click="close">X</a>
      </div>
    </div>
  </div>
</template>

<script>
import EDLocationSearch from "../../EDLocation/EDLocationSearch.vue";
import FlightDateTimeSelector from "./FlightDateTimeSelector.vue";

export default {
  name: "MultiCityRow",
  components: {
    EDLocationSearch,
    FlightDateTimeSelector,
  },
  props: {
    index: Number,
    value: {
      type: Object,
      required: true,
    },
    notAlone: {
      type: Boolean,
    },
    minDate: {
      type: Date,
      default: () => {
        return new Date();
      },
    },
    focusedDate: {
      type: Date,
      default: () => {
        return new Date();
      },
    },
  },
  data() {
    return {

    };
  },
  computed: {
    fromTitle() {
      //return this.index === 0 ? "From (e.g. LAX, BOS)" : "";
      return "From (e.g. LAX, BOS)";
    },
    toTitle() {
      //return this.index === 0 ? "To (e.g. LAX, BOS)" : "";
      return "To (e.g. LAX, BOS)";
    },
    departTitle() {
      return this.index === 0 ? "Depart" : "";
    },
    deleteClass() {
      return this.index === 0
        ? "column is-1 is-vertical-center-first"
        : "column is-1 is-vertical-center-regular";
    },
  },
  methods: {
    updateRow() {
      this.$emit("update", this.value);
    },
    nextBox() {
      this.$refs.toLocationInput.setUp();
    },
    toggleActive(val) {
      this.value.fromLoc = val;
      this.$refs.fromLocationInput.setUp();
    },
    setArrivalLocation(val) {
      this.value.toLoc = val;

      this.value.depDate.date = this.focusedDate;
      this.$refs.departDate.toggle();
      //this.$emit("nextLeg", [this.index, val]);
    },
    close() {
      // console.log(this.index)
      // this.$el.parentNode.removeChild(this.$el);
      this.$emit("remove", this.index);
      // destroy the vue listeners, etc
      // this.$destroy();
      // remove the element from the DOM

      // this.$parent.children.splice(this.index, 1)
      // this.$el.parentNode.removeChild(this.$el);
    },
  },
  watch: {
    value() {
      this.$emit("input", this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.is-vertical-center-first {
  padding-top: 2.8rem;
  padding-left: 0rem;
  display: flex;
  align-items: center;
}
.is-vertical-center-regular {
  padding-top: 0.9rem;
  padding-left: 0rem;
  display: flex;
  align-items: center;
}

// mobile
@media screen and (max-width: 1023px) {
  .is-vertical-center-regular {
    padding-top: 0.9rem;
    padding-left: 0rem;
    display: flex;
    align-items: center;
  }
}
// pc
@media screen and (min-width: 1024px) {
  .is-vertical-center-regular {
    padding-top: 0.9rem;
    padding-left: 0rem;
    padding-right: 0rem;
    display: flex;
    align-items: center;
  }
}
</style>
